import ActionTypes from './actionTypes';

import { v4 as uuidv4 } from 'uuid';

export function addToastAlert(message, variant = 'neutral', dismissable = false, x = 'center', y = 'top') {
  const id = uuidv4();
  window.dataLayer.push({
    event: 'Card_Portal_Toast_Alert',
    message: message,
  });
  return {
    type: ActionTypes.TOAST_ALERT.ADD,
    payload: { id, message, variant, dismissable, x, y }
  };
}

export function resetToastAlert() {
  return {
    type: ActionTypes.TOAST_ALERT.RESET,
  };
}

export function addToastAlertModal() {
  return {
    type: ActionTypes.TOAST_ALERT.ADD_MODAL,
  };
}

export function resetToastAlertModal() {
  return {
    type: ActionTypes.TOAST_ALERT.RESET_MODAL,
  };
}
